import Moment from 'moment'

let defaultStartDate = Moment('2023-01-01').format('YYYY-MM-DD')
let defaultEndDate = Moment('2023-06-01').format('YYYY-MM-DD')

const state = {
  startDate: defaultStartDate,
  endDate: defaultEndDate
}

const mutations = {
  SET_START_DATE (state, startDate) {
    state.startDate = startDate
  },

  SET_END_DATE (state, endDate) {
    state.endDate = endDate
  }
}

const actions = {
  setStartDate: function ({commit}, startDate) {
    if (typeof startDate === 'undefined') {
      commit('SET_START_DATE', defaultStartDate)
    } else {
      commit('SET_START_DATE', startDate)
    }
  },

  setEndDate: function ({commit}, endDate) {
    if (typeof endDate === 'undefined') {
      commit('SET_END_DATE', defaultEndDate)
    } else {
      commit('SET_END_DATE', endDate)
    }
  }
}

const getters = {
  startDate: function (state) {
    return state.startDate
  },

  endDate: function (state) {
    return state.endDate
  }
}

export const FilterDateRange = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/filters/FilterDateRange.js